import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import React from 'react'
import { useS4LContext } from '@s4l/react-context'

import { Typography } from '@s4l/ds'
import AncillaryCard from './AncillaryCard'
import { ListOfAncillary } from '@s4l/stayforlong/booking/ListOfAncillary'

import { type AncillaryTypes } from '@s4l/stayforlong/booking/AncillaryType'
import styles from './index.module.css'

export interface IAncillariesBannerProps {
  ancillariesJSON: ReturnType<ListOfAncillary['toJSON']>
  onClick?: (data: { type: AncillaryTypes }) => void
}

function noop() {} // eslint-disable-line @typescript-eslint/no-empty-function

function AncillariesBanner({ ancillariesJSON, onClick = noop }: Readonly<IAncillariesBannerProps>) {
  const { i18n } = useS4LContext()

  if (!ancillariesJSON) return null

  const ancillaries = ListOfAncillary.fromJSON(ancillariesJSON)

  if (ancillaries.isEmpty()) return null

  return (
    <div className={styles.ancillaries} data-testid="ancillaries-container">
      <Typography as="h5" variant="title" size="s">
        {i18n.formatMessage({ id: 'addons-products.title' })}
      </Typography>

      <div className={styles.ancillariesContent}>
        {
          ancillaries.map(ancillary => (
            <AncillaryCard key={ancillary.link} {...ancillary.toJSON()} onClick={onClick} />
          )) as React.ReactNode[]
        }
      </div>
    </div>
  )
}
AncillariesBanner.displayName = 'AncillariesBanner'
export default withErrorBoundary(AncillariesBanner)
